import gql from 'graphql-tag';

export const UPDATE_PROPOSAL_MENU = gql`
  mutation ($input: UpdateProposalMenuInput) {
    updateProposalMenu(input: $input) {
      proposalMenuId
    }
  }
`;
